import { AxiosInstance } from 'axios';
import { BaseApi } from 'services/api/base-api';
import { ApiResult } from 'services/api/result.type';
import { TrackEventsRequest } from './dto';

export class AnalyticsApi extends BaseApi {
  public constructor (protected readonly api: AxiosInstance) {
    super();

    this.trackEvents = this.trackEvents.bind(this);
  }

  public async trackEvents (data: TrackEventsRequest): ApiResult<void> {
    return await this.post<void>('/analytics/events', data);
  }
}
